/*
 * This is a place to share feedback related enums and types common to all feedback related types.
 */

export enum FeedbackType {
  DOCUMENT_REVIEW = 'DOCUMENT_REVIEW',
}

export enum AutoResolutionType {
  REMINDER = 'REMINDER',
  AUTO_CANCEL = 'AUTO_CANCEL',
  AUTO_APPROVAL = 'AUTO_APPROVAL',
  UNKNOWN = 'UNKNOWN',
}
